import { QuantitySelector, GoogleIcon } from '@wiggot/web-components'

interface IDetailCounter {
  name: string
  icon?: string
  onChange: (value: number) => void
  onChangeInputValue?: (value: number) => void
  defaultQuantity?: number
  value?: number
  className?: string
  minQuantity?: number
}

export const DetailCounter = ({
  name,
  icon,
  onChange,
  onChangeInputValue,
  defaultQuantity,
  value,
  className,
  minQuantity
}: IDetailCounter) => {
  return (
    <div className={`flex flex-row justify-between w-full ${className || ''}`}>
      <p className="font-normal text-md flex items-center mb-4">
        {icon && <GoogleIcon name={icon} className="mr-2" />}
        {name}
      </p>
      <QuantitySelector
        className="text-primary text-headline-m"
        defaultQuantity={defaultQuantity}
        maxQuantity={20}
        minQuantity={minQuantity ?? 1}
        onChange={onChange}
        onChangeInputValue={onChangeInputValue}
        value={value}
      />
    </div>
  )
}
